import {createSelector} from '@reduxjs/toolkit'

import {getOrderSheetId} from '@web/helpers/path'
import {locationSelector} from '@web/slices/router'

import type {RootState} from '../interfaces'

/**
 * seqID 가져오기
 * 우선순위
 * 1. store에 저장되어있는 값
 * 2. url parsing
 */
export const seqIDSelector = createSelector(
    (state: RootState) => state.common.seqID,
    locationSelector,
    (seqID, location) => {
        if (seqID) {
            return seqID
        }

        const nextOrderSheetId = getOrderSheetId(location.pathname)
        if (!nextOrderSheetId) {
            throw new Error('seqID를 확인할 수 없습니다.')
        }

        return nextOrderSheetId
    },
)
